import { useState, useCallback } from 'react';
import _ from 'underscore';

/**
 * Hook to manage an input value with debounced on change
 * @returns {Array} An array of the debounced value and the debounced updater
 */
export default function useDebounceInputValue(waitTime = 1000) {
  const [, setUserValue] = useState('');
  const [value, setValue] = useState('');

  const debouncedSetValue = useCallback(
    _.debounce((nextValue) => setValue(nextValue), waitTime),
    [],
  );

  const handleChange = (event) => {
    const { value: nextValue } = event.target;

    setUserValue(nextValue);
    debouncedSetValue(nextValue);
  };

  return [value, handleChange];
}
